import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromSearch from '../reducers/search.reducer';

export const getSearchResultsState = createSelector(fromFeature.getSearchtate, (state: fromFeature.SearchState) => state.searchResults);

export const getAllSearchResults = createSelector(getSearchResultsState, fromSearch.GetAllResults);
export const getSearchResultsLoaded = createSelector(getSearchResultsState, fromSearch.getSearchLoaded);
export const getSearchResultsLoading = createSelector(getSearchResultsState, fromSearch.getSearchLoading);
export const getSearchQuery = createSelector(getSearchResultsState, fromSearch.getSearchQuery);

export const getRankedSearchResults = createSelector(getAllSearchResults, results => {
  return results.slice().sort((a, b) => (b.relevance > a.relevance ? 1 : -1));
});

export const getAllMagazineSearchResults = createSelector(getSearchResultsState, fromSearch.GetAllMagazineResults);
export const getMagazineSearchResultsLoaded = createSelector(getSearchResultsState, fromSearch.getMagazineSearchLoaded);
export const getMagazineSearchResultsLoading = createSelector(getSearchResultsState, fromSearch.getMagazineSearchLoading);

export const getRankedMagazineSearchResults = createSelector(getAllMagazineSearchResults, results => {
  return results.slice().sort((a, b) => (b.relevance > a.relevance ? 1 : -1));
});
